import { LocationStrategy, Location } from '@angular/common';
import { EventEmitter, Inject, Injectable, InjectionToken } from '@angular/core';
import { SubscriptionLike } from 'rxjs';
import { filter } from 'rxjs/operators';

export const GATEWAY_BASE_PATH = new InjectionToken<string>('gateway.basepath');

@Injectable({
  providedIn: 'root'
})
export class GatewayLocationService extends Location {
  static buildGatewayBaseHref(dxtBasePath?, microAppPath?) {
    const strRegex = `^${dxtBasePath ? `(${dxtBasePath})?` : ''}/workspaces/([^/]+)`;
    const workspaceName = globalThis.location.pathname?.match(new RegExp(strRegex))?.[dxtBasePath ? 2 : 1] ?? '';
    let worskpacePrefix = '';
    if (workspaceName) {
      worskpacePrefix = '/workspaces/' + workspaceName
    }
    return dxtBasePath + worskpacePrefix + microAppPath + '/';
  }

  subject: EventEmitter<any> = new EventEmitter();

  constructor(private platformStrategy: LocationStrategy, @Inject(GATEWAY_BASE_PATH) private gatewayBasepath) {
    super(platformStrategy);
    console.log('***** GatewayLocationService constructor')
  }

  buildStateUrl(path: string): string {
    const doubleReg = /\/\//gi;

    return (this.platformStrategy.getBaseHref().replace(this.gatewayBasepath ?? '/', '') + path).replace(doubleReg, '/');
  }

  replaceState(path: string, query: string = '', state: any = null): void {
    // extend Angular's History state with the app-shell 'url' property (this allows app-shell to handle popstate events
    // and top-level navigation correctly---see app-shell RoutingService for details on how it handles popstate events)
    state.url = this.buildStateUrl(path);
    super.replaceState(path, query, state);
  }

  go(path: string, query: string = '', state: any = null): void {
    // extend Angular's History state with the app-shell 'url' property (this allows app-shell to handle popstate events
    // and top-level navigation correctly---see app-shell RoutingService for details on how it handles popstate events)
    state.url = this.buildStateUrl(path);
    super.go(path, query, state);
  }

  /**
   * Subscribes to the platform's `popstate` events.
   *
   * @param value Event that is triggered when the state history changes.
   * @param exception The exception to throw.
   *
   * @returns Subscribed events.
   */
  subscribe(
    onNext: (value: PopStateEvent) => void, onThrow?: ((exception: any) => void) | null,
    onReturn?: (() => void) | null): SubscriptionLike {

    /**
     * Filter popstate events that don't apply to this microapp.
     * 
     * The intention is to ignore cases where a back button click loads a state that belongs to a different micro-frontend or to the app-shell.
     * The active micro-frontend should not handle this state because it could cause an error or route to a default route or an error page.
     * 
     * Instead, the app-shell should handle these routes and load the appropriate micro-frontend.
     */
    return (this as any)._subject.pipe(filter(event => {
      console.log(`***** GatewayLocationService: ${this.platformStrategy.path()} - ${this.platformStrategy.getBaseHref()}`)
      return this.platformStrategy.path().includes(this.platformStrategy.getBaseHref());
    })).subscribe(
      { next: onNext, error: onThrow, complete: onReturn }
    );
  }
}
